import { ApplicationSettings } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApi } from './fetchFromApi';

export const fetchApplicationSettings = () =>
  fetchFromApi<ApplicationSettings>(
    `${getParams().context}s/${getParams().contextId}/applications/tablomat`
  ).then((data) =>
    data.properties.reduce<Record<string, boolean>>((settings, { key, value }) => {
      settings[key] = value === 'true';
      return settings;
    }, {})
  );
